/**
 * Decodes the JWT bearer token and returns the company ID from the "ci" claim.
 * The "ci" claim is the same company ID the gateway sets as the "company-id" header,
 * ensuring the path variable satisfies the backend's validateCompanyId check.
 *
 * Shared by every ERP provider that needs the company ID client-side (e.g. to construct
 * ConfigurationService before the configuration response is available) to avoid
 * duplicating the same JWT-decoding logic in each ERP's utils.
 */
export const getCompanyIdFromToken = (token: string): number => {
    try {
        const payload = token.split('.')[1];
        const decoded = JSON.parse(atob(payload.replace(/-/g, '+').replace(/_/g, '/')));
        const id = Number(decoded?.ci);
        return isNaN(id) ? 0 : id;
    } catch {
        return 0;
    }
};